import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'https://api-invoice.ainixit.com/api';

const initialState = {
  watermarkText: 'SAMPLE',
  isLoading: false,
  error: null,
};

// Get watermark text
export const getWatermarkText = createAsyncThunk(
  'settings/getWatermarkText',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/settings/watermark-text`);
      return response.data.watermarkText;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch watermark text');
    }
  }
);

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWatermarkText.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getWatermarkText.fulfilled, (state, action) => {
        state.isLoading = false;
        state.watermarkText = action.payload;
      })
      .addCase(getWatermarkText.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = settingsSlice.actions;
export default settingsSlice.reducer;
